module.exports = {"svg":{"$":{"width":"128","height":"96","xmlns":"http://www.w3.org/2000/svg"},"g":[{"path":[{"$":{"d":"M64.125 56.975L120.188.912A12.476 12.476 0 0 0 115.5 0h-103c-1.588 0-3.113.3-4.513.838l56.138 56.137z"}},{"$":{"d":"M64.125 68.287l-62.3-62.3A12.42 12.42 0 0 0 0 12.5v71C0 90.4 5.6 96 12.5 96h103c6.9 0 12.5-5.6 12.5-12.5v-71a12.47 12.47 0 0 0-1.737-6.35L64.125 68.287z"}}]}]}}


//////////////////
// WEBPACK FOOTER
// ./~/xml-loader!./src/svg/email.svg
// module id = 375
// module chunks = 0